<template>
  <modal v-if="showModal" class="advanced-duplication-modal"  :mdBackdrop="false">
    <template slot="header">
      <h3>Advanced duplication</h3>
      <md-button
        class="md-simple md-just-icon md-round modal-default-button"
        @click="closeModal"
      >
        <md-icon>clear</md-icon>
      </md-button>
    </template>

    <template slot="body">
      <md-toolbar
        class="md-transparent md-theme-default md-elevation-0 md-toolbar-filters"
      >
      <md-list class="list">
        <HotelsSelect 
            multiple
            v-model="selectedIds"
            :hotels="hotels"
          />
      </md-list>
      </md-toolbar>
    </template>
    <template slot="footer">
      <md-card-actions class="footer">
        <md-button 
          v-if="selectedIds.length > 0"
          class="md-success" 
          @click="duplicateItem()"
        >
          Duplicate
        </md-button>
        <md-button 
          class="md-default"
          @click="closeModal()"
        >
          Close
        </md-button>
      </md-card-actions>
    </template>
  </modal>
</template>

<script>
import { Modal } from "@/components";
import HotelsSelect from "./HotelsSelect.vue";

export default {
  name: "AllotmentBatchModal",
  components: {
    Modal,
    HotelsSelect
  },
  props: {
    hotels: {
      type: Array
    }
  },
  data() {
    return {
      selectedIds: [],
      showModal: false
    }
  },
  methods: {
    openModal() {
      this.selectedIds = []
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
    duplicateItem() {
      this.$emit("duplicateItem", this.selectedIds);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/md/_variables.scss";

.advanced-duplication-modal {

    h3 {
      color: $brand-primary;
      font-size: 130%;
    }

  .list {
    margin: 0 auto;
  }

  .footer {
    margin-top: 1.5rem;
  }

}
</style>
